<template>
    <div class="page-class"
        :class="{'farmer': userType == 'farmer', 'subdist': userType == 'subdist', 'dist': userType == 'dist', 'sale': userType == 'sale'}">
        <div class="page-wrapper">
            <div class="page-content"
                v-if="isAccountLoaded">
                <nav-bar
                    class="about-nav"
                    :pageName="navbarName"
                    :userType="userType" 
                    :isShowBack="true"
                    :isShowCurveBottom="false"
                    @clickBack="clickBack"></nav-bar>
                <div id="about_us_img">
                    <img class="img-fluid" src="../../../assets/icon/newversion/static/AboutUsImg.png" alt="about" />
                </div>
                <div id="about_us_content">
                    <div class="about-us-headline theme-txt">{{lbl.aboutus.headline}}</div>
                    <div id="about_us_content_txt" class="about_us_content_txt" v-html="lbl.aboutus.content"></div>
                </div>
                <div id="about_us_logo">
                    <div class="about-us-headline theme-txt">{{lbl.aboutus.headline_product}}</div>
                    <div class="logo-row">
                        <div class="logo-img">
                            <img class="img-fluid" src="../../../assets/logo/aboutus/2.png" />
                        </div>
                        <div class="logo-img">
                            <img class="img-fluid" src="../../../assets/logo/aboutus/5.png" />
                        </div>
                        <div class="logo-img">
                            <img class="img-fluid" src="../../../assets/logo/aboutus/3.png" />
                        </div>
                        <div class="logo-img">
                            <img class="img-fluid" src="../../../assets/logo/aboutus/6.png" />
                        </div>
                        <div class="logo-img">
                            <img class="img-fluid" src="../../../assets/logo/aboutus/4.png" />
                        </div>
                        <div class="logo-img">
                            <img class="img-fluid" src="../../../assets/logo/aboutus/7.png" />
                        </div>
                        <div class="logo-img">
                            <img class="img-fluid" src="../../../assets/logo/aboutus/8.png" />
                        </div>
                        <div class="logo-img">
                            <img class="img-fluid" src="../../../assets/logo/aboutus/9.png" />
                        </div>
                        <div class="logo-img">
                            <img class="img-fluid" src="../../../assets/logo/aboutus/10.png" />
                        </div>
                        <div class="logo-img">
                            <img class="img-fluid" src="../../../assets/logo/aboutus/11.png" />
                        </div>
                    </div>
                </div>
            </div>

            <div class="page-bg"></div>
        </div>
    </div>
</template>
<script>
//mixin
import AccountMixin from "@/mixin/AccountMixin.js";
//helper
import Locale from '@/helper/locale/locale.js';
import { TrackingService } from "@/helper/TrackingHelper.js";
//component
import NavBar from "@/components/Layout/NavBar/NavBar.vue";
export default {
    name: 'about-us',
    mixins: [AccountMixin],
    components: {
        NavBar
    },
    computed: {
        userType: function () {
            return this.$store.state.userType;
        }
    },
    data: function() {
        return {
            lbl: Locale.getLbl(),
            navbarName: "",

            trackingService: new TrackingService(this),
            trackingScreenName: 'aboutus',
            trackingEventCategory: 'aboutus_page',
        };
    },
    created: function () {
        this.navbarName = this.lbl.aboutus.nav_name;

        this.trackingService.screenName(this.trackingScreenName);
        this.trackingService.event(this.trackingEventCategory, 'view_about_us', null, null);
    },
    methods: {
        clickBack: function () {
            this.$router.push('/profile');

            this.trackingService.event(this.trackingEventCategory, 'click_back', null, null);
        }
    }
}
</script>
<style lang="scss" scoped>
    @import "./About.scss";
</style>
<style lang="scss">
.about-nav {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
}
</style>
